import { StorageServiceComposite } from '@gafe/common-ui';

import { parseJwtPayload } from '@/utils/parse-jwt-payload';

import { IHeartbeat } from './IHeartbeat';

export class HeartbeatService implements IHeartbeat {
  constructor(private $storage: StorageServiceComposite) {}

  async getExpiration(): Promise<number> {
    const portalAccessToken = await this.$storage.get('gaf-pp-storage.portalAccessToken', null);
    const parsedJwt = parseJwtPayload(portalAccessToken);

    return Promise.resolve(parsedJwt.exp * 1000);
  }
}
